import React, { useEffect, useState } from "react";
import { reduxForm, Field, FieldArray } from "redux-form";
import { Grid, Header, Divider, Button, Label } from "semantic-ui-react";
import { renderTextField, NoteEditorField } from "../formcomponents";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice, ImageUrl } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
import ContactFieldArr from "./ContactFieldArr";
import ImageFileUploadFileId from "../formcomponents/ImageFileUploadFileId";
const validate = (values) => {
  const errors = {};

  // Required field validations
  if (!values.visaCategory) {
    errors.visaCategory = "Required";
  }
  if (!values.contactEmail) {
    errors.contactEmail = "Required";
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.contactEmail)
  ) {
    errors.contactEmail = "Invalid email address";
  }

  // Validate contactDetails array for correct email format
  if (values.contactDetails && values.contactDetails.length > 0) {
    errors.contactDetails = values.contactDetails.map((contact, index) => {
      const contactErrors = {};
      if (contact) {
        // Ensure contact is not undefined
        if (
          contact.contactEmail &&
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(contact.contactEmail)
        ) {
          contactErrors.contactEmail = "Invalid email address";
        }
      }
      return Object.keys(contactErrors).length > 0 ? contactErrors : null;
    });
  }

  return errors;
};

const ContactCreate = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const [isLoading, setisLoading] = useState(false);
  const navigate = useNavigate();
  const { id, catId } = useParams();
  const userDetail = userData();
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [cardFrontImagetemp, setcardFrontImage] = useState(null);
  const [cardBackImagetemp, setcardBackImage] = useState(null);
  useEffect(() => {
    if (id !== "null") {
      getWorkList();

      setisLoading(true);
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
    }
  }, []);
  const getWorkList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/getContactDetails", {
        ssContactId: id,
      })
      .then((res) => {
        console.log("res", res.data);
        setisLoading(false);
        console.log(JSON.stringify(res.data, null, 2));
        setcardFrontImage(res?.data?.cardFrontImage);
        setcardBackImage(res?.data?.cardBackImage);
        const tempData = res.data;
        const filterData = tempData;
        console.log("filterData", filterData);

        initilizeData(filterData);
      })
      .catch((error) => {
        setisLoading(false);
        console.log(error);
      });
  };

  const initilizeData = (filterData) => {
    props.initialize({
      ...filterData,
      ssContactId: filterData.ssContactId,
      address: filterData.address,
      state: filterData.state,
      country: filterData.country,
      companyName: filterData.companyName,
      contactDetails: filterData.contactDetails,
      contactPersonName: filterData.contactPersonName,
      contactNumber: filterData.contactNumber,
      contactEmail: filterData.contactEmail,
    });
  };
  const sumbitForm = (values) => {
    console.log("valuesvaluesvaluesvaluesvalues", values);
    let tempArr = [];
    if (values.contactDetails != "") {
      values.contactDetails.forEach((item) => {
        tempArr.push({
          ssContactDetailsId: item?.ssContactDetailsId,
          contactType: 2,
          typeId: item?.typeId,
          contactNumber: item?.contactNumber,
          contactEmail: item?.contactEmail,
          contacName: item?.contacName,
        });
      });
    }
    const submitObject = {
      ...values,
      contactDetails: tempArr, // Replace existing contactDetails with tempArr
      userId: userDetail.userId,
      categoryId: catId,
    };

    console.log(JSON.stringify(submitObject, null, 2));
    axios
      .post(BaseUrlInvoice + "/accounts/createContact", submitObject)
      .then((res) => {
        console.log("res", res.data);
        if (res.data.errCode === 200) {
          Swal.fire({
            icon: "success",
            title: "sccess",
            text: "Created",
          });
          navigate(`/list-contact-details/${res.data.categoryId}`);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Create Contact
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      {isLoading === false && (
        <>
          <Grid.Row>
            <Grid columns="three">
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name="companyName"
                    label="Company Name"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="contactPersonName"
                    label="Contact Person Name"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="address"
                    label="Address"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row>
            <Grid columns="three">
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name="state"
                    label="State"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="country"
                    label="Country"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="contactNumber"
                    label="Contact Number"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row>
            <Grid columns="three">
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name="contactEmail"
                    label="Contact Email"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="groupId"
                    label="Group ID"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="remarks"
                    label="Remarks"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row>
            <FieldArray name="contactDetails" component={ContactFieldArr} />
          </Grid.Row>
          <Grid.Row>
            {" "}
            <Button
              floated="right"
              positive
              // disabled={buttonDisable}
              onClick={handleSubmit((values) =>
                sumbitForm({
                  ...values,
                })
              )}
            >
              Save
            </Button>
            <Button
              floated="right"
              negative
              disabled={pristine || submitting}
              onClick={reset}
            >
              Cancel
            </Button>{" "}
          </Grid.Row>
          <Grid.Row>
            <Grid columns="two">
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name="cardFrontImage"
                    label="Card Front Image"
                    component={ImageFileUploadFileId}
                  />
                  {cardFrontImagetemp && (
                    <img
                      src={ImageUrl + cardFrontImagetemp}
                      height="300"
                      width="500px"
                    />
                  )}
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="cardBackImage"
                    label="Card Back Image"
                    component={ImageFileUploadFileId}
                  />
                  {cardBackImagetemp && (
                    <img
                      src={ImageUrl + cardBackImagetemp}
                      height="300"
                      width="500px"
                    />
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>

          <br />
          <br />
          <br />
          <br />
          <br />
          <Grid.Row>
            <div className="label123">Additional Remarks</div>
            <Field
              key="field"
              name="additionalRemarks"
              label="Additional Remarks"
              id="inputEditorText"
              disabled={false}
              component={NoteEditorField}
            />
          </Grid.Row>
          <Divider hidden />
        </>
      )}
    </div>
  );
};

export default reduxForm({
  form: "ContactCreate",
  validate,
})(ContactCreate);
